import { AxiosResponse } from "axios";
import axiosInstance from "../interceptors/axiosInstance";
import { ListResponseDto } from "../dtos/ListResponseDto";
import { selectorTransversal } from "../dtos/selector";


export const getUsuarios = async () => {

    const axiosResponse: AxiosResponse<ListResponseDto<selectorTransversal>> = await axiosInstance.get(`siscred-api-transversal/v1/usuario/obtener-datos-usuario`);

    return axiosResponse;
}

